import { Column, CreateDateColumn, Entity, VersionColumn, PrimaryGeneratedColumn, UpdateDateColumn, ManyToOne, OneToMany } from "typeorm";
import {EnquiryLifecycleStatusEnum, OrderTypeEnum, SourceFromEnum} from '@gtpl/shared-models/enquiry-management'
import { EnquiryProdctsEntity } from "./enquiry-products";
import { EnquiryLogEntity } from "./enquiry-log";
import { CostSheetEntity } from "../../costing/entity/cost-sheet-entity";
import { MFGCostsEntity } from "../../costing/entity/mfg-costs-entity";
import { FreightForwardExpensesEntity } from "../../costing/entity/freight-forward-expenses-entity";
import { EnquiryPackBomEntity } from "./enquiry-pack-bom.entity";


@Entity("enquiries")
export class EnquiriesEntity {
    @PrimaryGeneratedColumn('increment',{
        name:"enquiry_id"
    }) 
    enquiryId: number;

    @Column('varchar',{
        name:'enquiry_number',
        nullable:false,
        length:50
    })
    enquiryNumber: string; 

    @Column('enum',{
        name:"order_type",
        nullable:false,
        enum:OrderTypeEnum
    })
    orderType: OrderTypeEnum

    @Column('enum',{
        name:'source_from',
        nullable:false,
        enum:SourceFromEnum
    })
    sourceFrom: SourceFromEnum;

    @Column('int',{
        name:'agent_id',
        nullable:false
    })

    agentId: number; 

    @Column('int',{
        name:'buyer_id',
        nullable:false
    })
    buyerId: number; 

    @Column('int',{
        name:'sale_person_id',
        nullable:true
    })
    salePersonId: number;

    @Column('date',{
        name:'enquiry_date',
        nullable:false
    })
    enquiryDate: Date;

    @Column('decimal',{
        name:'no_of_containers',
        nullable:false,
        precision:10,scale:1
    })
    noOfContainers: number;

    @Column('int',{
        name:'agent_address_id',
        nullable:true
    })
    agentAddressId: number;

    @Column('int',{
        name:'buyer_address_id',
        nullable:true
    })
    buyerAddressId: number;

    @Column('int',{
        name:'country_id',
        nullable:false
    })
    countryId: number;

    @Column('int',{
        name:'destination_id',
        nullable:false
    })
    destinationId: number;

    @Column('date',{
        name:'etd',
        nullable:true
    })
    etd: Date;
    @Column('date',{
        name:'to_etd',
        nullable:true
    })
    toEtd: Date;

    @Column('date',{
        name:'eta',
        nullable:true
    })
    eta: Date;

    @Column('int',{
        name:'delivery_terms_id',
        nullable:true
    })
    deliveryTermsId: number;

    @Column('int',{
        name:'payment_terms_id',
        nullable:true
    })
    paymentTermsId: number;

    @Column('int',{
        name:'shipment_terms_id',
        nullable:false
    })
    shipmentTermsId: number;

    @Column('int',{
        name:'processing_unit_id',
        nullable:true
    })
    processingUnitId: number;

    @Column('int',{
        name:'manufacturing_unit_id',
        nullable:true
    })
    manufacturingUnitId: number;

    @Column('int',{
        name:'currency_id',
        nullable:false
    })
    currencyId: number;

    @Column('text',{
        name:'remarks',
        nullable:true
    })
    remarks: string;

    @Column('enum',{
        name:'life_cycle_status',
        nullable:false,
        enum:EnquiryLifecycleStatusEnum
    })
    lifeCycleStatus: EnquiryLifecycleStatusEnum;

    @Column('int',{
        name:'unit_id',
        nullable:false
    })
    unitId: number; 

    // @Column('text',{
    //     name:'enquiry_reject_reason',
    //     nullable:true
    // })
    // enquiryRejectReason: string; 

    @Column('int',{
        name:'enquiry_reject_reason',
        nullable:true
    })
    enquiryRejectReason: number; 

    @Column("boolean", {
        nullable: false,
        default: false,
        name: 'freeze_status'
    })
    freezeStatus: boolean | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean | null;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at"
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

    @Column('int',
    {name:'sales_commision',
        default:0
    })
    salesCommission:number

    @Column('int',
    {name:'uom_id'})
    uomId:number

    
    @Column('int',{
        name:'costing_reject_reason',
        nullable:true
    })
    costingRejectReason: number

    @Column("boolean", {
        nullable: true,
        default: false,
        name: 'is_regenerated'
    })
    isRegenearted: boolean | null;

    @Column('text',{
        name:'enquiry_reject_description',
        nullable:true
    })
    enquiryRejectDescription: string;

    @Column('boolean',{
        name:'is_fob',
        nullable:false
    })
    isFOB : boolean

    @Column('text',{
        name:'cancel_reason',
        nullable:true
    })
    cancelReason: string;
    @OneToMany(() =>EnquiryProdctsEntity ,enquiryProduct => enquiryProduct.enquiryEntity,{cascade:true})
    enquiryProduct: EnquiryProdctsEntity[];

    @OneToMany(() =>EnquiryLogEntity ,enquiryLog => enquiryLog.enquiryEntity,{cascade:true})
    enquiryLog: EnquiryLogEntity[];

    @OneToMany(() =>CostSheetEntity ,costSheet => costSheet.enquiryEntity,{cascade:true})
    costSheet: CostSheetEntity[];

    @OneToMany(() =>MFGCostsEntity ,mfgCosts => mfgCosts.enquiryEntity,{cascade:true})
    mfgCosts: MFGCostsEntity[];

    @OneToMany(() =>FreightForwardExpensesEntity ,fe => fe.enquiryEntity,{cascade:true})
    freightExp: FreightForwardExpensesEntity[];

    // @OneToMany(()=> EnquiryPackBomEntity, epb=> epb.enquiryEntity,{cascade: true})
    // enquiryPackInfo: EnquiryPackBomEntity[]

}

